function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M502.6,192.6c-8.8-35.3-25.5-61.9-61-61.9h-45.8v54.2c0,42.1-35.7,77.5-76.3,77.5H197.4c-33.4,0-61,28.6-61,62.1v116.3 c0,33.1,28.8,52.6,61,62.1c38.6,11.3,75.8,13.4,122.1,0c30.7-8.9,61-26.9,61-62.1v-46.5H258.5v-15.5h183.1c35.5,0,48.7-24.8,61-61.9 C515.4,278.4,514.8,241.6,502.6,192.6L502.6,192.6z M327.1,425.1c12.7,0,23,10.4,23,23.2c0,12.9-10.3,23.3-23,23.3 c-12.6,0-23-10.5-23-23.3C304.2,435.4,314.5,425.1,327.1,425.1z M191.8,247h122.1c33.9,0,61-28,61-62.1V68.5 c0-33.1-27.9-57.9-61-63.5C272.9-1.8,228.5-1.5,191.8,5c-51.7,9.1-61,28.2-61,63.5v46.5h122.2v15.5h-168 c-35.5,0-66.6,21.4-76.3,61.9c-11.2,46.5-11.7,75.5,0,124.1c8.7,36.1,29.4,61.9,64.9,61.9h41.9v-55.8 C115.4,282.5,150.3,247,191.8,247L191.8,247z M184.1,84c-12.7,0-23-10.4-23-23.2c0.1-12.9,10.3-23.3,23-23.3c12.6,0,23,10.5,23,23.3 S196.8,84,184.1,84z"
});

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.084d8b42.svg";
export { ForwardRef as ReactComponent };